export function cn(...values) {
  return values
    .flatMap((v) => {
      if (!v) return []
      if (Array.isArray(v)) return v
      if (typeof v === 'object') {
        return Object.entries(v)
          .filter(([, on]) => Boolean(on))
          .map(([k]) => k)
      }
      return [String(v)]
    })
    .join(' ')
    .trim()
}

